import { forwardRef } from 'react'

import { Input } from '@zet/design-system/input'
import { Stack, YStack } from '@zet/design-system/layout'
import { B2, B5 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'
import { Controller } from 'react-hook-form'

import { useAddBankAccountForm } from './hooks'

type Props = {
  onChangeError: () => void
  showPopup: () => void
  setIsSubmitDisabled: (x: boolean) => void
  setIsSubmitLoading: (x: boolean) => void
}

export const BankDetailsForm = forwardRef((props: Props, ref) => {
  const { control, errors, paymentModes } = useAddBankAccountForm({
    props,
    ref,
  })
  return (
    <YStack {...props}>
      <Stack className="space-y-2">
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <Stack>
              <B2>
                {i18n.t('bankDetailsForm.panCard')}{' '}
                <B2 className="text-error-50">*</B2>
              </B2>
              <Input
                placeholder="Eg: PKQN1439S"
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                type={errors.panCard ? 'error' : 'primary'}
                showErrorText={errors.panCard ? errors.panCard.message : ''}
                autoCapitalize="characters"
                maxLength={10}
              />
            </Stack>
          )}
          name="panCard"
        />
      </Stack>
      <Stack className="mt-3">
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <Stack>
              <B2>
                {i18n.t('bankDetailsForm.bankName')}
                <B2 className="text-error-50">*</B2>
              </B2>
              <Input
                placeholder={i18n.t('bankDetailsForm.egSBI')}
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                type={errors.bankName ? 'error' : 'primary'}
                showErrorText={errors.bankName ? errors.bankName.message : ''}
              />
            </Stack>
          )}
          name="bankName"
        />
      </Stack>
      <Stack className="mt-3">
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <Stack>
              <B2>
                {i18n.t('bankDetailsForm.accountNumber')}
                <B2 className="text-error-50">*</B2>
              </B2>
              <Input
                keyboardType="numeric"
                placeholder="Eg: 4532 2356 3452 2355 2345"
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                type={errors.accountNumber ? 'error' : 'primary'}
                showErrorText={
                  errors.accountNumber ? errors.accountNumber.message : ''
                }
              />
            </Stack>
          )}
          name="accountNumber"
        />
        <B5 className="text-grays-50 mt-1">
          {i18n.t('bankDetailsForm.addBankNote')}
        </B5>
      </Stack>
      <Stack className="mt-3">
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <Stack>
              <B2>
                {i18n.t('bankDetailsForm.ifscCode')}
                <B2 className="text-error-50">*</B2>
              </B2>
              <Input
                placeholder="Eg: SBI000001"
                onBlur={onBlur}
                onChangeText={onChange}
                value={value}
                maxLength={11}
                type={errors.ifscCode ? 'error' : 'primary'}
                showErrorText={errors.ifscCode ? errors.ifscCode.message : ''}
              />
            </Stack>
          )}
          name="ifscCode"
        />
      </Stack>
    </YStack>
  )
})
